import mock from './mock'

import "./data/acceuil/index.js"
import "./data/fonct/index"
import "./data/service/index"
import "./data/reference/index"
import "./data/capture/index"

mock.onAny().passThrough(); // forwards the matched request over network
